export default __webpack_public_path__ + "static/media/medocta.d53cc0ff.jpg";